import { BackupMemberRoleEnum } from 'src/graphql/schema';

export const roleOptions = [
  { label: 'Manager', value: BackupMemberRoleEnum.Manager },
  { label: 'Viewer', value: BackupMemberRoleEnum.Viewer },
];

export const roleOptionsDict = roleOptions.reduce((acc, { value, label }) => ({ ...acc, [value]: label }), {
  [BackupMemberRoleEnum.Owner]: 'Manager',
}) as Record<BackupMemberRoleEnum, string>;
